import { useMemo } from 'react';

import type { Seat } from '@cineamo/ui/src/seat-map/typedefs';

import { useCartProvider } from '@cineamo/composables/src/providers/cartProvider';

/** The room's seats with what the cart knows: locked by someone else, selected by this guest, refused by the API. */
export function useSeatsWithLockState(seatsProp: Seat[]): Seat[] {
    const { items, selectedSeats, seatLocks, errors } = useCartProvider();
    return useMemo(() => {
        return seatsProp.map((seat) => {
            const result = { ...seat };
            const seatLock = seatLocks?.find((seatLock) => seatLock._embedded?.seat?.id === seat.id);
            const cartItem = items.find((item) => item._embedded?.product?._embedded?.seat?.id === seat.id);
            const isSelected = selectedSeats.some((s) => s.id === seat.id);
            const isError = errors.some((error) => error.seatId === seat.id);

            if (seatLock && !cartItem) {
                result.isLocked = true;
                result.isSelected = false;
            }

            if (isSelected) {
                result.isSelected = true;
                result.isLocked = false;
            }

            result.isError = isSelected && isError;
            return result;
        });
    }, [seatsProp, seatLocks, items, selectedSeats, errors]);
}
